import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const fromBeforeToCardNumberValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const from = group.get('fromCardNumber')?.value;
  const to = group.get('toCardNumber')?.value;
  if (from != null && to != null && from > to)
  {
    return { fromAfterTo: true };
  }
  return null;
};
